import { Tools, Task, ActionEvent } from "./_types";

type Callable<T> = () => T;
function safeCall<T>(fn: Callable<T>) {
  try {
    return fn()
  } catch (err) {
    console.log('safeCall::error', err)
  }
}

export default function HandleToolCalls({
  iframeRef,
  tools,
  toolId,
  task_id,
  duration,
  onNavStart,
  onNavEnd,
}: {
  iframeRef: React.RefObject<HTMLIFrameElement | null>;
  tools: Tools;
  toolId: string;
  task_id?: string;
  duration?: number;
  onNavStart?: () => void;
  onNavEnd?: () => void;
}) {
  const tool = tools[toolId];
  if (!tool) {
    console.log('tool not found', { tools, toolId })
    return
  }

  const tasks = tool.tasks;
  let task: Task | undefined;

  if (task_id && tasks) {
    task = tasks[task_id];
  }

  console.log({
    tool,
    tasks,
    task_id,
    task: task_id ? tasks[task_id] : null,
    hasIframeAccess: typeof iframeRef.current?.contentDocument !== 'undefined',
    iframeUrl: iframeRef.current?.src,
  })

  if (iframeRef.current && tool.url && !iframeRef.current.src.includes(tool.url)) {
    // console.log(tool.url);
    onNavStart?.()
    iframeRef.current.src = tool.url;
    iframeRef.current.addEventListener("load", () => {
      onNavEnd?.()
      handleTask();
    });
  } else {
    handleTask();
  }

  function handleTask() {
    // console.log("HandleToolCalls::handleTask", task);
    if (!task) return


    const action = task?.action;
    duration = duration ?? task?.duration ?? 1;

    if (!action) return
    // console.log("HandleToolCalls::handleTask", action);

    switch (action) {
      case "show":
        {
          // console.log(tool, task, action);
          if (tool.tool_id === "images") {
            showImage()
            // console.log("Showing Image")
          } else if (tool.tool_id === 'videos') {
            showVideo()
            // console.log("Showing Video")
          }
          return "showing"
        }
      case "click":
        {
          actionClick()
          return "clicking";
        }
      case "scroll":
        {
          actionScroll()
          return "scrolling";
        }
    }

    function actionClick() {
      if (iframeRef.current?.contentDocument && task) {
        const target = task?.target;
        const element = iframeRef.current.contentDocument.querySelector(target) as HTMLElement;
        console.log('HandleToolCalls::click', element)

        if (element) {
          safeCall(() => element.scrollIntoView({ behavior: "smooth", block: "center" }))
          setTimeout(() => {
            safeCall(() => element.focus())
            safeCall(() => element.click())
          }, 300);
        }
      }
    }

    function actionScroll() {
      if (iframeRef.current && task) {
        const target = task?.target;
        const element = iframeRef.current.contentWindow?.document.querySelector(target) as HTMLElement;
        console.log('HandleToolCalls::action', element)

        if (element) {
          setTimeout(() => {
            safeCall(() => element.scrollIntoView({ behavior: "smooth", block: "center" }))
            safeCall(() => element.focus())
          }, duration);
        }
      }
    }

    function showImage() {
      // console.log("calling showImage", task);
      const targetUrl = task?.target
      if (!targetUrl) {
        // console.log("No targetUrl found");
        return;
      };

      safeCall(() => {
        const element = document.querySelector<HTMLImageElement>("#sonaris-image-preview")
        if (!element) {
          // console.log("No element found");
          return
        };

        element.src = targetUrl
        element.classList.add('open')

        const ev = new ActionEvent("toggle-image-open", targetUrl)
        window.dispatchEvent(ev)
      })
    }

    function showVideo() {
      const targetUrl = task?.target
      // console.log("calling from showVideo", targetUrl);
      if (!targetUrl) return;
      // console.log("before safeCall");
      safeCall(() => {
        const element = document.querySelector<HTMLImageElement>("#sonaris-video-preview")
        if (!element) {
          // console.log("in showVideo, no element found");

          return
        };

        const source = element.querySelector('source')
        if (source) {
          source.src = targetUrl
        } else {
          element.src = targetUrl
        };

        element.classList.add('open')

        element.addEventListener('load', () => {
          const ev = new ActionEvent("start-audio-playback")
          window.dispatchEvent(ev)
          // console.log("dispatched start-audio-playback");

        }, { once: true })

        const ev = new ActionEvent("toggle-video-open", targetUrl)
        window.dispatchEvent(ev)
        // console.log("dispatched toggle-video-open");
      })
    }
  }
}

